import {useGetUnreadCommunicationCountQuery} from '@dms/api/core';
import {useIsCommunicationReadStateEnabled, usePermissions} from '@dms/shared';

import {isDefinedNonZeroValue} from 'shared/web';

import {formatBadgeNumber} from '../utils/formatBadgeNumber';

/**
 * Badge of the Communication menu item: the unread messages the user owns. Pushes refresh it
 * through `useRefreshCommunicationUnreadState`; it also refetches on window focus.
 */
export function useCommunicationMenuBadgeValue() {
  const [canReadSyncedMessages] = usePermissions({permissionKeys: ['syncedMessageRead']});
  const isReadStateEnabled = useIsCommunicationReadStateEnabled();

  const {data} = useGetUnreadCommunicationCountQuery(undefined, {
    skip: !canReadSyncedMessages || !isReadStateEnabled,
    refetchOnFocus: true,
  });

  return isDefinedNonZeroValue(data?.count) ? formatBadgeNumber(data.count) : undefined;
}
